// NOTICE: KAPTION-INTEGRATION
// whatsapp-sent-template-tracking.RENDERING.5
//
// Derive a human-readable one-line preview for a quoted WhatsApp-template
// message. A campaign / direct template send is materialized (by
// KaptionSentTemplateMatcherService) as a message whose `content` is only the
// template name/slug for rows created before the interpolated body was stored
// on `content`. The reply-preview bubble (Base.vue) renders the quoted
// message's `content`, so without this it shows a slug like
// "consulta_disponibilidad_v2_prod_v2" instead of the message the customer saw.
//
// Precedence mirrors WhatsAppTemplate/Index.vue: prefer the interpolated body
// that KaptionSentTemplateRendererService produced at send time
// (content_attributes.template_params.rendered.body), then the rendered header,
// then the raw processed body params joined together. The template_params JSONB
// is not always deep-camelCased by the dashboard serializer, so accept both
// key styles defensively.

/**
 * @param {object} [contentAttributes] - a message's content_attributes.
 * @returns {string} the template body preview, or '' when the message is not a
 *   template or carries no usable body text.
 */
export const extractTemplateBody = contentAttributes => {
  const tp =
    contentAttributes?.templateParams || contentAttributes?.template_params;
  if (!tp) return '';

  const rendered = tp.rendered || tp.Rendered;
  if (rendered?.body) return rendered.body;
  if (rendered?.header) return rendered.header;

  const processed = tp.processedParams || tp.processed_params || {};
  if (processed.body && typeof processed.body === 'object') {
    const parts = Object.values(processed.body).filter(Boolean).map(String);
    if (parts.length) return parts.join(' ');
  }

  return '';
};
